import { mapGetters } from "vuex";
import * as AreaBranchTeamService from "./../../Service/AreaBranchTeam.service";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";
export default {
  data() {
    return {
      areasList: [],
      selectedArea: {},
      officeList: [],
      teamList: [],
      employeeAreaTeamOfficeList: [],
      headers: [
        {
          text: "Area",
          align: "left",

          value: "selectedArea"
        },
        { text: "Team", value: "selectedTeam" },
        { text: "Branch ", value: "selectedOffice" },
        { text: "Actions", value: "name", sortable: false }
      ]
    };
  },
  props: {
    employeeId: {
      type: Number
    }
  },
  computed: {
    showAddArea() {
      if (
        this.employeeAreaTeamOfficeList.filter(x => x.isEdit == true).length ==
        0
      ) {
        return false;
      }
      return true;
    },
    ...mapGetters(["getAllAreaTeamBranch"])
  },
  async mounted() {
    await this.getAllAreas();
    await this.getEmployeeAreaTeamOfficeList();
  },
  watch: {
    getAllAreaTeamBranch(newValue, oldValue) {}
  },
  methods: {
    assignNewAreaTeamOffice() {
      if (
        this.employeeAreaTeamOfficeList.filter(x => x.isEdit == true).length ==
        0
      ) {
        var areaTeamOffice = {
          EmployeeId: this.employeeId,
          Area: "",
          Team: "",
          Office: "",
          isEdit: true
        };

        this.employeeAreaTeamOfficeList.unshift(areaTeamOffice);
      }
    },
    async getEmployeeAreaTeamOfficeList() {
      var result = await AreaBranchTeamService.getEmployeeAreaTeamOfficeList(
        this.employeeId
      );

      if (result.error == false) {
        result.data.forEach(x => (x.isEdit = false));

        this.employeeAreaTeamOfficeList = result.data;
      }
    },
    async deleteAreaTeamOffice(areaTeamOfficeObj) {
      if (areaTeamOfficeObj.isEdit == true) {
        var index = this.employeeAreaTeamOfficeList.findIndex(
          x => x.isEdit == true
        );
        this.employeeAreaTeamOfficeList.splice(index, 1);
      } else {
        var result = await AreaBranchTeamService.DeleteEmployeeAreaTeamOffice(
          areaTeamOfficeObj
        );

        if (result.error == false) {
          var pendingEdit = this.employeeAreaTeamOfficeList.filter(
            x => x.isEdit == true
          );
          result.data.forEach(x => (x.isEdit = false));
          this.employeeAreaTeamOfficeList = result.data;

          if (pendingEdit.length > 0) {
            this.employeeAreaTeamOfficeList.unshift(pendingEdit[0]);
          }
          this.$store.commit(
            "toaster",
            toasterModel("Deleted Successfully", toasterColor.success)
          );
        }
      }
    },
    async assignAreaTeamOffice(areaTeamOfficeObj) {

      if (areaTeamOfficeObj.Area.length < 1) {
        this.$store.commit(
          "toaster",
          toasterModel("Please select an area to continue ", toasterColor.info)
        );
        return false;
      }
      var areaTeamOffice = {
        EmployeeId: this.employeeId,
        Area: areaTeamOfficeObj.Area.Area,
        Team:
          areaTeamOfficeObj.Team.Team == null ||
          areaTeamOfficeObj.Team.Team == "All"
            ? null
            : areaTeamOfficeObj.Team.Team,
        Office:
          areaTeamOfficeObj.Office.Office == null ||
          areaTeamOfficeObj.Office.Office == "All"
            ? null
            : areaTeamOfficeObj.Office.Office
      };

      ///#region  IsAlready Existing

      var abc = this.isAlreadyExisting(areaTeamOffice);
      if (this.isAlreadyExisting(areaTeamOffice) == false) {
        var result = await AreaBranchTeamService.InsertEmployeeAreaTeamOffice(
          areaTeamOffice
        );

        if (result.error == false) {
          result.data.forEach(x => (x.isEdit = false));
          this.employeeAreaTeamOfficeList = result.data;
          this.$store.commit(
            "toaster",
            toasterModel("Assigned Successfully", toasterColor.success)
          );
        }
      }
      // else {
      //   this.$store.commit(
      //     "toaster",
      //     toasterModel("Already Assigned", toasterColor.error)
      //   );
      // }
    },
    isAlreadyExisting(areaTeamOffice) {
      // Existing Area Team Office
      var existingAreaTeamOffice = this.employeeAreaTeamOfficeList.filter(
        x => x.isEdit == false
      );

      //ex-- 1-null-null
      if (areaTeamOffice.Team == null && areaTeamOffice.Office == null) {
        var isAreaExisting = existingAreaTeamOffice.filter(
          x => x.Area == areaTeamOffice.Area
        );

        if (isAreaExisting.length > 0) {
          this.$store.commit(
            "toaster",
            toasterModel("Please delete existing", toasterColor.info)
          );
          return true;
        }
      }

      // ex 1-1-null
      if (areaTeamOffice.Team != null && areaTeamOffice.Office == null) {
        var isFullAreaSelected = existingAreaTeamOffice.filter(
          x =>
            x.Area == areaTeamOffice.Area && x.Team == null && x.Office == null
        );

        if (isFullAreaSelected.length > 0) return true;
        var isFullTeamSelected = existingAreaTeamOffice.filter(
          x => x.Area == areaTeamOffice.Area && x.Team == areaTeamOffice.Team
        );

        if (isFullTeamSelected.length > 0) return true;
      }

      // 1-1-1
      if (areaTeamOffice.Team != null && areaTeamOffice.Office != null) {
        var isFullAreaSelected = existingAreaTeamOffice.filter(
          x =>
            x.Area == areaTeamOffice.Area && x.Team == null && x.Office == null
        );

        if (isFullAreaSelected.length > 0) return true;
        var isFullTeamSelected = existingAreaTeamOffice.filter(
          x =>
            x.Area == areaTeamOffice.Area &&
            x.Team == areaTeamOffice.Team &&
            x.Office == null
        );

        if (isFullTeamSelected.length > 0) return true;

        var isSameOfficeAlreadySelected = existingAreaTeamOffice.filter(
          x =>
            x.Area == areaTeamOffice.Area &&
            x.Team == areaTeamOffice.Team &&
            x.Office == areaTeamOffice.Team
        );

        if (isSameOfficeAlreadySelected.length > 0) return true;
      }

      return false;
    },
    async getAllAreas() {
      var result = await AreaBranchTeamService.getAllAreaTeamBranch();

      if (result.error == false && result.data.length > 0) {
        this.areasList = result.data;
        this.changeArea(this.areasList[0]);
      }
    },
    changeArea(selectedArea) {
      this.teamList = this.defaultTeamDropDown();
      this.teamList.push(...selectedArea.listTeams);

      this.changeTeam(this.teamList[0]);
    },
    changeTeam(selectedTeam) {
      this.officeList = this.defaultOfficeDropdown();
      this.officeList.push(...selectedTeam.listOffices);
    },
    defaultTeamDropDown() {
      return [
        {
          Team: "All",
          TeamString: null,
          listOffices: []
        }
      ];
    },
    defaultOfficeDropdown() {
      return [
        {
          Office: "All",
          OfficeString: null
        }
      ];
    }
  }
};
